'use strict';

var React = require('react');
var styled = require('styled-components');
require('../../theme/breakpoints.js');
require('../../helpers/css-units.js');
require('../../theme/theme.js');
var number = require('../../helpers/number.js');
require('imask');
var useRefAndForward = require('../../hooks/useRefAndForward.js');
require('resize-observer-polyfill');
var component = require('../Portal/component.js');
var helpers = require('./helpers.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Overlay = React.forwardRef(({ variant, targetRef, isOpened, maxHeight, disablePortalForOptions, ...props }, ref) => {
    const overlayRef = useRefAndForward.useRefAndForward(null, ref);
    const theme = styled.useTheme();
    const { overlaySpaceToTarget } = theme.designTokens;
    const maxWidth = helpers.useMaxWidth({ targetRef, isOpened, variant, overlaySpaceToTarget });
    const positionX = helpers.usePositionX({ overlayRef, targetRef, isOpened, variant });
    const positionY = helpers.usePositionY({ overlayRef, targetRef, isOpened, overlaySpaceToTarget });
    const isReadyForDisplay = number.isNumber(maxWidth) && number.isNumber(positionX) && number.isNumber(positionY);
    const isDisplayed = isOpened && isReadyForDisplay;
    const overlayProps = {
        'aria-hidden': !isDisplayed,
        maxHeight: maxHeight ?? null,
        ref: overlayRef,
        isDisplayed,
        positionX,
        positionY,
        maxWidth,
        variant,
        disablePortalForOptions,
        ...props,
    };
    if (disablePortalForOptions) {
        return React__default.default.createElement(styles.Styled.Container, { ...overlayProps });
    }
    return (React__default.default.createElement(component.Portal, null,
        React__default.default.createElement(styles.Styled.Container, { ...overlayProps })));
});

exports.Overlay = Overlay;
//# sourceMappingURL=component.js.map
